import {InjectionToken} from '@angular/core';
import {Languages} from './languages';

export const SUPPORTED_LANGS = new InjectionToken<Languages>('SUPPORTED_LANGS');
